import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { GetAllCartItems } from '../../redux/Slices/CartSlice'

const UseGetAllItemsCart = () => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true)
    const [ItemsCartNumber, setItemsCartNumber] = useState(0)
    const [cartId, setCartId] = useState("0")
    const [CouponNameText, setCouponNameText] = useState("")
    const [priceAfterDiscount, setpriceAfterDiscount] = useState("")
    const [TotalPrice, setTotalPrice] = useState(0)
    const [AllCartItems, setAllCartItems] = useState()
    const { getAllCartItems } = useSelector(state => state.CartReducer)

    // handle get all cart items
    const getAllItems = async () => {
        setLoading(true)
        await dispatch(GetAllCartItems())
        setLoading(false)
    }

    // run the get all cart items function
    useEffect(() => {
        getAllItems()
    }, [])

    // handle get all cart items request response
    useEffect(() => {
        if (loading === false) {
            if (getAllCartItems && getAllCartItems.status === 200) {
                setItemsCartNumber(getAllCartItems.data.numOfCartItems)
                setAllCartItems(getAllCartItems.data.data)
                setCartId(getAllCartItems.data.data._id)
                setTotalPrice(getAllCartItems.data.data.totalCartPrice)
                if (getAllCartItems.data.data.coupon) {
                    setCouponNameText(getAllCartItems.data.data.coupon)
                } else {
                    setCouponNameText("")
                }
                if (getAllCartItems.data.data.totalAfterDiscount) {
                    setpriceAfterDiscount(getAllCartItems.data.data.totalAfterDiscount)
                } else {
                    setpriceAfterDiscount("")
                }
            }
            else {
                setItemsCartNumber(0)
                setAllCartItems([])
            }
        }
    }, [loading])


    return [ItemsCartNumber, AllCartItems, CouponNameText, priceAfterDiscount, cartId,TotalPrice]
}

export default UseGetAllItemsCart
